/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { EndorsementService } from "../../services/endorsement.service";
import { Endorsement } from "../../model/Endorsement";
import {NgxSpinnerService} from 'ngx-spinner';
import {BaseMessageComponent} from '../../common/base-message.component';

@Component({
    selector: 'app-endorsements',
    templateUrl: './endorsements.component.html',
    styleUrls: ['./endorsements.component.less'],
    standalone: false
})
export class EndorsementsComponent extends BaseMessageComponent implements OnInit {
    public _endorsements: Endorsement[];
    indexWithChanges: number[] = [];

    constructor(private endorsementService: EndorsementService,
        private spinnerService: NgxSpinnerService,
        cdr: ChangeDetectorRef) {
        super(cdr);
    }

    ngOnInit() {
        this.getAllEndorsements();
    }

    getAllEndorsements(): void {
        this.spinnerService.show();
        this._endorsements = [];
        this.indexWithChanges = [];
        this.endorsementService.getAllEndorsements().subscribe(value => {
            this._endorsements = value;
            this.cdr.detectChanges();
        },
            err => {
                console.log(err);
                alert(err);
                this.spinnerService.hide();
            },
            () => {
                this.spinnerService.hide();
            }
        );
    }

    addNew(name: string, desc: string) {
      if (name.trim() == "" || desc.trim() == "") {
        alert("Please add name and description before saving a new record.");
      } else {
        this.spinnerService.show();
        var newEndorsement = new Endorsement();
        newEndorsement.endorsementName = name;
        newEndorsement.endorsementDesc = desc;
        newEndorsement.active = true;

        this.endorsementService.addNew(newEndorsement).subscribe(value => {
            //success
            this._endorsements = null;
            this.getAllEndorsements();
          }, (error) => {
            //failed
            console.error(error);
            if (error.status=='409')
              alert("Duplicate Value(s) found.");
            else
              alert(error.message);
            this.spinnerService.hide();
          },
          () => {
            this.spinnerService.hide();
          });
      }
    }

    updateIndexes(index) {
        if (this.indexWithChanges.indexOf(index) === -1) {
            this.indexWithChanges.push(index);
        }
        console.log(this.indexWithChanges);
    }

    saveChanges() {
        this.spinnerService.show();
        if (this.indexWithChanges.length > 0) {
            for (var i = 0; i < this.indexWithChanges.length; i++) {
                var idx = this.indexWithChanges[i];
                this.endorsementService.updateEndorsement(this._endorsements[idx]).subscribe(value => {
                    console.log(this._endorsements[idx] + " saved.")
                }, (error) => {
                    //failed
                    console.error(error);
                    this.spinnerService.hide();
                    if (error.status=='409')
                      alert("Duplicate Value(s) found.");
                    else
                      alert(error.message);
                },
                    () => {
                      this.spinnerService.hide();
                        this.indexWithChanges = [];
                    });
            }
            setTimeout(() => {
                this.getAllEndorsements();
            }, 3000);
        } else {
          this.spinnerService.hide();
          alert("No changes to save.");
        }
    }
}
